module.exports = __webpack_public_path__ + "media/images/pocstock-invite-team-ad-a338c49bc8aa309133b0ad79382e893e.png";